import React, { lazy } from 'react'
import { DashSwitch } from '@retailer-platform/dashboard/routing'
import { DomainRedirect, DomainRoute } from '../utils/domain/routingComponents'
import { partnerPickDevicesAccessControl } from '../access-control/partnerPickDevicesAccess.configuration'
import { usePageTitleKey } from '../utils/domain/usePageTitleKey'

const PartnerPickDevicesListPage = lazy(() => import('../pages/list/PartnerPickDevicesListPage'))
const PartnerPickDevicesEditPage = lazy(() => import('../pages/edit/PartnerPickDevicesEditPage'))
// @hygen:inject page-import

/**
 * Wrapper component that resolves the dynamic scope picker title based on
 * the partner bulk delivery entitlement. This is needed because scopePicker.titles
 * is a static prop — we need a component boundary to call usePageTitleKey().
 */
const PartnerPickDevicesListRoute = () => {
  const titleKey = usePageTitleKey()

  return (
    <DomainRoute
      exact
      route="partner-pick-devices-list"
      component={PartnerPickDevicesListPage}
      scopePicker={{
        titles: [titleKey],
      }}
    />
  )
}

export const partnerPickDevicesRouter = (
  <DomainRoute route="partner-pick-devices" accessControl={partnerPickDevicesAccessControl}>
    <DashSwitch>
      <PartnerPickDevicesListRoute />
      <DomainRoute exact route="partner-pick-devices-edit" component={PartnerPickDevicesEditPage} />
      {/* @hygen:inject router-route 
        injection point for routes, please do not delete */}

      <DomainRedirect fromRoute="partner-pick-devices" toRoute="partner-pick-devices-list" />
    </DashSwitch>
  </DomainRoute>
)
